// extracted by mini-css-extract-plugin
export default {"required":"CircuitRelationForm_required__I1iUw","baseFlex":"CircuitRelationForm_baseFlex__eREP4"};